// TYPES
import type { FailedResponse, SuccessResponse } from '..'

// UTILITIES
import { createResponseObj, generateHeaders } from '..'
import { evervaultProxyUrl } from '.'


type GetCardResponse = (SuccessResponse & {
    card: GroupCard
}) | FailedResponse

export class GetCardRequest extends Request {
    private constructor(cardId: string, init?: RequestInit) { super(`${evervaultProxyUrl}/card/${cardId}`, init) }
    static async init(cardId: string, init?: RequestInit) {
        return new GetCardRequest(cardId, {
            ...init,
            method: 'GET',
            headers: await generateHeaders("Clerk-Token", init?.headers),
        })
    }

    static async fetch(...args: Parameters<typeof this.init>) {
        const request = await this.init(...args)
        return await request.fetch()
    }

    public async fetch(): Promise<GroupCard> {
        const response = await fetch(this)
        const data = createResponseObj<GetCardResponse>(await response.json())
        console.info("Get Card Results:", data)
    
        switch (data.status) {
            case 'successful': return data.card
            case 'failed': throw data
            default: throw new Error(`Unsupported Status: ${data}`)
        }
    }
}